import script from "./AddingAPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./AddingAPaymentMethod.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__